<template>
  <div class="filter-group">
    <div class="filter-group__header" v-if="showHeader">
      <span class="filter-group__title">{{ groupTitle }}</span>
      <v-btn
        v-if="canRemove"
        icon
        size="x-small"
        variant="text"
        @click="$emit('remove_group')"
        :title="$t('filter_tree.remove_group')"
      >
        <v-icon size="small">fas fa-trash-alt</v-icon>
      </v-btn>
    </div>
    <filter-item
      v-for="(filter, index) in filters"
      :key="filter.id || ('filter_' + index)"
      :id="'filter_' + index"
      @clear="clear(filter.id)"
      @set_value="set_value(filter.id, $event)"
      :value="filter.value"
      :label="filter.label"
      :input="filter.input"
      :filter="filter"
      :options="filter.options"
      :label_options="filter.label_options"
      :is_date="filter.is_date"
      :non_deletable="non_deletable_filter_types.includes(filter.type)"
      :non_togglable="non_togglable_filter_types.includes(filter.type)"
    ></filter-item>
    <add-filter
      :initial_filter="initial_filter"
      style="margin-top: 12px;"
      @add_filter="$emit('add_filter', $event)"
    ></add-filter>
  </div>
</template>

<script>
import FilterItem from "@/components/asset_filter/FilterItem";
import AddFilter from "@/components/asset_filter/AddFilter";

export default {
  name: "FilterGroup",
  components: { FilterItem, AddFilter },
  props: {
    filters: { required: true },
    groupIndex: { type: Number, default: 0 },
    showHeader: { type: Boolean, default: false },
    canRemove: { type: Boolean, default: false },
    initial_filter: { default: false },
    non_deletable_filter_types: { default: () => [] },
    non_togglable_filter_types: { default: () => [] },
  },
  computed: {
    groupTitle() {
      return this.$t('filter_tree.group_n', { n: this.groupIndex + 1 });
    },
  },
  methods: {
    clear(filter_id) {
      this.$emit('clear_filter_id', filter_id);
    },
    set_value(filter_id, value) {
      this.$emit('set_value', filter_id, value);
    },
  },
};
</script>

<style scoped>
.filter-group {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  padding: 10px 12px 12px;
  margin-bottom: 10px;
  background: rgba(0, 0, 0, 0.02);
}
.filter-group__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}
.filter-group__title {
  font-size: 0.85rem;
  font-weight: 600;
  opacity: 0.75;
}
</style>
